<template>
    <div class="categ_info" v-if="obj_to_null(this.cur_item)">

        <div class="redraw_block" v-if="!is_set_data">

            <info_field f_uniq="ct3"
                        f_type="group_name"
                        :is_disabled="true"
                        :f_title="__t('ROLE.GROUP')"
                        :f_val="active_group_title">
            </info_field>

            <info_field f_uniq="ct355"
                        f_type="pin"
                        :is_disabled="true"
                        :f_title="__t('PIN')"
                        :f_val="cur_item.pin">
            </info_field>


            <info_field f_uniq="ct1"
                        f_type="title"
                        :is_disabled="false"
                        @update_categ="change_atr"
                        :f_title="__t('NAME')"
                        :f_val="cur_item.title">
            </info_field>

            <div class="allow_in" >
                <b-row>
                    <b-col>
                        <div>
                            <yes_no key="PUBLISHED" title="PUBLISHED"
                                @input="val => change_atr('published', val)"
                                v-model="cur_item.published"
                            >
                            </yes_no>
                        </div>
                    </b-col>
                </b-row>
            </div>

        </div>
    </div>

</template>

<script>
import Info_field from "../../../sys/info_field.vue";
import yes_no from "../../../sys/radio/yes_no.vue";


import Fuse from 'fuse.js';
import vSelect from 'vue-select'
export default {
    name: "role_info",
    components: {yes_no, Info_field,vSelect},
    props : {
        role_item : {
            type : Object
        }
    },

    created() {
        this.cur_item = this.role_item;
        this.load_provider();
    },


    data() {
        return {
            cur_item : {
                'provider_id' : 0
            },
            cur_provider : {
                'id' : 0,
                'name' : "",
                'type' : ""
            },

            is_load: false,
            restaurants : [],
            locations : [],
            is_set_data : false,
        }
    },
    methods :  {

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: ['title', 'uniq_id', 'address'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async load_provider() {
            await api.get('/internal/v1/roles/'+ parseInt(this.cur_item.provider_id)).then(({data}) => {
                this.is_load = false;
                this.cur_provider = data.data;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,position : "b-toaster-top-left"})
            });
        },

        change_atr(atr_name,atr_val) {
            this.$emit('on_change_attribute',atr_name,atr_val);
        }
    },
    computed : {

        is_disabled () {
            return this.cur_item.id > 0;
        },


        active_group_title () {
            return this.__t(this.cur_provider.name);
        },

    },
}
</script>

<style scoped>

</style>
